<template>
  <v-container grid-list-md>
    <profile></profile>
    <h1 class="headline">My Classes</h1>
    <v-layout class="mt-2" row wrap> 
      <classroom-card 
        v-for="(classroom, i) in classrooms" 
        :key="classroom.classroom_id"
        :classroom="classroom.classroom"
        :inc="i"
      ></classroom-card>
    </v-layout>

    <v-dialog v-model="classCodeModal" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Join a class</span>
        </v-card-title>
        <v-card-text>
          <span class="body-1">Enter the class code that was given by your instructor.</span>
          <v-text-field
            label="Class Code"
            v-model="classCode"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="classCodeModal = false" :disabled="loading">Cancel</v-btn>
          <v-btn class="elevation-0" dark color="green" :loading="loading" @click="enterClassCode">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tooltip left lazy>
      <v-speed-dial
        slot="activator"
        v-model="fab"
        :bottom="bottom"
        :right="right"
        :direction="direction"
        :transition="transition"
        fixed
      >
        <v-btn
          slot="activator"
          fab
          color="red darken-1"
          dark
          hover
          v-model="fab"
          @click="classCodeModal = true"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-speed-dial>
      <span>Join a class</span>
    </v-tooltip>
    <!-- <h1>{{classrooms}}</h1> -->
  </v-container>
</template>

<script>
import VueNotifications from 'vue-notifications'
import axios from 'axios'
import ClassroomCard from './ClassroomCard.vue'
import Profile from './Profile.vue'
export default {
  components: {
    ClassroomCard, Profile
  },
  data(){
    return {
      classCodeModal: false,
      classCode: '',
      loading: false,
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
    }
  },
  created(){
    this.$store.dispatch('student/FETCH_CLASSES')
  },
  methods: {
    async enterClassCode(){
      try{
        this.loading = true
        let res = await axios.post('/api/enroll', {
          class_code: this.classCode
        }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
        this.classCodeModal = false
        this.loading = false
        this.$store.dispatch('student/FETCH_CLASSES')
        this.classCode = ''
      }catch(e){
        this.loading = false
        console.log(e)
        this.showErrorMsg({ title: 'Failed!', message: e.response.data.error.join(' ') })
      }
    }
  },
  computed: {
    classrooms(){
      return this.$store.getters['student/GET_CLASSES']
    }
  },
  notifications: {
    showSuccessMsg: { type: VueNotifications.types.success },
    showErrorMsg: { type: VueNotifications.types.error }
  }
}
// ZijCQq
</script>

<style>
.swal-title,
.swal-text,
.swal-button{
  font-family: 'Roboto',sans-serif;
}

.swal-button{
  background-color: #43a047;
}
</style>



// WEBPACK FOOTER //
// src/components/Student/Classrooms.vue